import { LinkTokens } from './types';

export const link: LinkTokens = {
  variants: {
    variant: {
      default: {
        color: 'primary.50',
        ':hover': {
          color: 'primary.90',
        },
      },
      inline: {
        color: 'primary.50',
        ':hover': {
          color: 'primary.90',
        },
      },
      legal: {
        color: 'neutral.80',
        ':hover': {
          color: 'neutral.90',
        },
      },
    },
    mode: {
      night: {
        color: 'neutral.0',
        ':hover': {
          color: 'neutral.40',
        },
      },
    },
  },
};
